import React, { useState } from "react";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import "./ExperienceAccordion.css";

function ExperienceAccordion({ sections }) {
  const [activeSection, setActiveSection] = useState(
    sections && sections.length ? sections[0].title : null
  );

  return (
    <div className="career-archive" aria-label="Experience archive">
      {sections.map((section, sectionIndex) => {
        const isOpen = activeSection === section.title;
        const recordCount = section.experiences.length;

        return (
          <article
            className={`career-archive-panel ${isOpen ? "is-open" : ""}`}
            key={section.title}
          >
            <button
              type="button"
              className="career-archive-trigger"
              onClick={() => setActiveSection(isOpen ? null : section.title)}
              aria-expanded={isOpen}
              aria-controls={`experience-section-${sectionIndex}`}
            >
              <span className="career-archive-index">
                {String(sectionIndex + 1).padStart(2, "0")}
              </span>
              <span className="career-archive-title">
                <b>{section.title}</b>
                <small>
                  {recordCount} {recordCount === 1 ? "record" : "records"}
                </small>
              </span>
              <span className="career-archive-status">
                {isOpen ? "COLLAPSE" : "EXPAND"}
              </span>
              <span className="career-archive-chevron" aria-hidden="true">
                ↓
              </span>
            </button>
            <div
              id={`experience-section-${sectionIndex}`}
              className="career-archive-content"
              aria-hidden={!isOpen}
            >
              <div className="career-archive-content-inner">
                {section.experiences.map((item, index) => (
                  <ExperienceCard
                    key={`${item.company}-${item.title}`}
                    index={index}
                    totalCards={recordCount}
                    experience={item}
                  />
                ))}
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}

export default ExperienceAccordion;
